export function getElementRect(element: HTMLElement) {
  // Округляем ширину в меньшую сторону, чтоб избежать ненужного показа стрелочек в случае дробных пикселей.
  const width = Math.floor(element.getBoundingClientRect().width);

  return {
    left: element.offsetLeft,
    right: element.offsetLeft + width,
    width,
  };
}
